import DOMPurify from 'dompurify';

const descriptionOptions = {
  ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'ul', 'ol', 'li', 'a'],
  ALLOWED_ATTR: ['href'],
};

export const sanitizeArtistDescription = (html = '') =>
  DOMPurify.sanitize(html, descriptionOptions);

export const artistDescriptionToPlainText = (html = '') =>
  DOMPurify.sanitize(html, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] })
    .replace(/\s+/g, ' ')
    .trim();
